import { z } from 'zod';

export namespace Column {
  export namespace Type {
    export const Schema = z.enum(['string', 'number', 'datetime', 'date']);
  }
  export type Type = z.infer<typeof Type.Schema>;

  export namespace Format {
    // Non-exhaustive; backend may extend. Prefer permissive string fallback if needed.
    export const Schema = z.enum([
      'text',
      'integer',
      'float',
      'datetime',
      'date',
      'duration',
    ]);
  }
  export type Format = z.infer<typeof Format.Schema>;

  export const Schema = z.object({
    id: z.string(),
    label: z.string(),
    type: z.union([Type.Schema, z.string()]),
    format: z.union([Format.Schema, z.string()]).optional(),
    sortable: z.boolean().optional(),
    filterable: z.boolean().optional(),
  });
}
export type Column = z.infer<typeof Column.Schema>;

export namespace Row {
  export const Schema = z.object({
    id: z.string(),
    // Cells now contain primitive values coming from backend
    cells: z.record(
      z.string(),
      z.union([z.string(), z.number(), z.boolean(), z.null()]),
    ),
  });
}
export type Row = z.infer<typeof Row.Schema>;

export namespace Table {
  export const Schema = z.object({
    columns: z.array(Column.Schema),
    rows: z.array(Row.Schema),
  });
}
export type Table = z.infer<typeof Table.Schema>;
